/**
 * Currency Filter
 * Input text only accept number and decimal ( , and . )
 */

import { utils } from '../../Foundation';

// # Class
export class CurrencyFilter {
  constructor(element) {
    this._refs = {
      el: element,
    };

    this._setInputFilter(this._refs.el);
  }

  /**
   * Filter input text can only include number and max value of 2 decimal
   * @param {Event} e - Event Interface
   */
  _setInputFilter(textbox) {
    ['input', 'keydown', 'keyup', 'mousedown', 'mouseup', 'select', 'contextmenu', 'drop'].forEach(
      function (event) {
        textbox.addEventListener(event, function () {
          const checkInputValue = utils.validateCurrencyField(this);
          if (checkInputValue) {
            this.oldValue = this.value;
            this.oldSelectionStart = this.selectionStart;
            this.oldSelectionEnd = this.selectionEnd;
            /* eslint-disable-next-line */
          } else if (this.hasOwnProperty('oldValue')) {
            this.value = this.oldValue;
            this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
          } else {
            this.oldValue = this.value;
            const commaPosition = this.oldValue.indexOf(',');
            const dotPosition = this.oldValue.indexOf('.');
            // remove dot thousand separator
            if (commaPosition > dotPosition) {
              return (this.value = this.oldValue.replace(/./g, ''));
            }
            // remove comma thousand separator
            if (commaPosition < dotPosition) {
              return (this.value = this.oldValue.replace(/,/g, ''));
            }
            // Fallback clear field
            this.value = '';
          }
        });
      },
    );
  }
}
